var render = function render(){var _vm=this,_c=_vm._self._c;return _c('n-full-screen',[_c('n-map',{ref:"map"}),_c('keep-alive',{attrs:{"include":_vm.keepAliveIncludedComponents}},[_c('router-view',{on:{"positions":_vm.onPositions}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }